import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { WaiterService } from '../../_service/waiter.service';

@Component({
  selector: 'app-payment-method',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './payment-method.component.html',
  styleUrl: './payment-method.component.scss'
})
export class PaymentMethodComponent implements OnInit {
  id: string | null;
  orderDetails: any;
  constructor(
    private route: ActivatedRoute,
    private service: WaiterService,
    private router: Router
  ) {
    this.id = route.snapshot.paramMap.get('id')
  }
  ngOnInit(): void {

  }

}
